import { ReportCoverageSummaryV1Schema, } from "../contracts/report-check-summary.js";
import { SEARCH_READINESS_RULE_SET_VERSION } from "../contracts/report-lifecycle.js";
import { clientSafeMessageForDisposition, dispositionForQualityCheck, } from "./report-governance-disposition.js";
export const WHAT_WE_DO_NOT_PROMISE = [
    "We do not guarantee search engine rankings or placement.",
    "We do not guarantee traffic, leads, or revenue from search.",
    "We do not guarantee Google Business Profile approval or verification timing.",
    "We do not guarantee review growth or reputation outcomes.",
];
export function buildCoverage(checks) {
    const total = checks.length;
    const passed = checks.filter((c) => c.disposition === "PASSED").length;
    const failed = checks.filter((c) => c.disposition === "FAILED").length;
    const warning = checks.filter((c) => c.disposition === "WARNING").length;
    const skipped = checks.filter((c) => c.disposition === "SKIPPED").length;
    const disabled = checks.filter((c) => c.disposition === "DISABLED").length;
    const unresolved = checks.filter((c) => c.disposition === "UNRESOLVED").length;
    const manager = checks.filter((c) => c.disposition === "MANAGER_EXCEPTION").length;
    const notRun = checks.filter((c) => c.disposition === "NOT_RUN").length;
    const coveragePercent = total > 0 ? Math.round((passed / total) * 100) : 0;
    const allowsFullPassLanguage = total > 0 && passed === total;
    return ReportCoverageSummaryV1Schema.parse({
        schemaVersion: "report-coverage-summary.v1.0",
        checksTotal: total,
        checksPassed: passed,
        checksFailed: failed,
        checksSkipped: skipped,
        checksDisabled: disabled,
        checksUnresolved: unresolved,
        checksManagerException: manager,
        checksNotRun: notRun,
        checksWarning: warning,
        coveragePercent,
        allowsFullPassLanguage,
    });
}
function hasLimitedCoverage(coverage) {
    return (coverage.checksSkipped > 0 ||
        coverage.checksDisabled > 0 ||
        coverage.checksNotRun > 0 ||
        coverage.checksManagerException > 0 ||
        coverage.checksUnresolved > 0 ||
        !coverage.allowsFullPassLanguage);
}
export function composeSearchReadinessSections(input) {
    const checks = input.qa.checks.map((c) => {
        const disposition = dispositionForQualityCheck(c, input.qa);
        return {
            schemaVersion: "report-check-summary.v1.0",
            checkId: c.checkId,
            disposition,
            severity: c.severity,
            clientSafeMessage: clientSafeMessageForDisposition(disposition),
            internalDetail: c.message,
        };
    });
    const coverage = buildCoverage(checks);
    const staleBanner = input.staleAgainstLatestPassing
        ? "This report is not current relative to the latest passing artifact for this project."
        : null;
    let headline = "Search readiness review complete.";
    if (!input.qa.completed) {
        headline = "Search readiness review incomplete — quality checks did not finish.";
    }
    else if (input.qa.status === "QA_FAIL") {
        headline = hasLimitedCoverage(coverage)
            ? "Search readiness review found blocking issues and limited coverage."
            : "Search readiness review found blocking issues.";
    }
    else if (input.qa.status === "QA_WARN" || coverage.checksWarning > 0) {
        headline = "Search readiness review completed with warnings.";
    }
    else if (hasLimitedCoverage(coverage)) {
        headline = "Search readiness review completed with limited coverage.";
    }
    return {
        coverage,
        checks,
        qaStatus: input.qa.status,
        headline,
        staleBanner,
    };
}
export function ruleSetVersionForCompose() {
    return SEARCH_READINESS_RULE_SET_VERSION;
}
//# sourceMappingURL=compose-search-readiness.js.map